export default __webpack_public_path__ + "static/warehouse-rentals-balthazaurus-scroll-02287801e6651004792a5c95b50a618a.mp4";